"use client";

import { Box, Pagination } from "@repo/ui";
import ScheduleCard from "./ScheduleCard";
import NoScheduleScreen from "../common/NoScheduleScreen";
import StructuredData from "../common/StructuredData";
import { useSuspenseQuery } from "@apollo/client/react";
import { useParams } from "next/navigation";
import { GET_EVENTS } from "@/graphql/queries/event-query";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { getCookie, hasCookie } from "cookies-next/client";
import useEventSchema from "@/hooks/useEventSchema";

export type ScheduleWrapperRef = {
  refetch: (variables?: {
    date?: string;
    modeOfTraining?: string;
  }) => Promise<any>;
  wrapperDivRef: React.RefObject<HTMLDivElement | null>;
};

const ScheduleWrapper = forwardRef<
  ScheduleWrapperRef,
  { modeOfTraining?: string }
>(({ modeOfTraining }, ref) => {
  const wrapperDivRef = useRef<HTMLDivElement>(null);

  const location = hasCookie("location") ? getCookie("location") : "";

  const { course, country, city } = useParams<{
    course: string;
    country?: string;
    city?: string;
  }>();
  const commonVariables = {
    slug: course,
    country: country ? country : location ? location : "us",
    city: city,
    perPage: 5,
    page: 1,
    modeOfTraining,
  };
  const { data: events, refetch } = useSuspenseQuery(GET_EVENTS, {
    variables: {
      ...commonVariables,
    },
  });

  useImperativeHandle(ref, () => ({
    refetch: (variables) => refetch(variables),
    wrapperDivRef: wrapperDivRef,
  }));

  const handlePagination = (value: number) => {
    refetch({
      ...commonVariables,
      page: value,
    });
  };
  const scheduleData = events?.events?.data;

  const paginationData = events?.events?.pageInfo;

  const isSchedule = events?.events?.data?.length > 0;

  const eventSchema = useEventSchema(scheduleData);

  return (
    <Box>
      {/* Schedules loop */}
      {isSchedule && (
        <Box
          className="pt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6"
          ref={wrapperDivRef}
        >
          {scheduleData?.map((event) => (
            <ScheduleCard key={event.id} data={event} />
          ))}
        </Box>
      )}
      {paginationData && (
        <Pagination
          itemsPerPage={paginationData.perPage}
          count={paginationData.total}
          page={paginationData.currentPage}
          onPageChange={handlePagination}
        />
      )}

      {!isSchedule && <NoScheduleScreen />}
      {eventSchema.length > 0 &&
        eventSchema.map((schema, index) => (
          <StructuredData key={"schedule-schema" + index} data={schema} />
        ))}
    </Box>
  );
});

ScheduleWrapper.displayName = "ScheduleWrapper";

export default ScheduleWrapper;
